export default __webpack_public_path__ + "static/media/icon1.6895fb65.png";